import * as React from 'react';
import { getToken } from '../../services/config/AdalConfig';
import { Redirect } from 'react-router-dom';
import { UserInfo } from '../Login/common/defaults';
import './assets/LoginAad.scss';
import * as urls from '../shared/urls';

export interface ILoginAADProps {
  setUserInfo: (user?: UserInfo) => void;
  serviceURL: string;
  currentUser: UserInfo;
}

interface ILoginAADState {
  loggedIn: boolean;
}

export default class LoginAAD extends React.Component<
  ILoginAADProps,
  ILoginAADState
> {
  constructor(props) {
    super(props);
    this.state = {
      loggedIn: false,
    };
  }

  componentDidMount() { }

  getCidUserWithADUser = () => {
    // Get application specific user information
    const headers = { Authorization: `Bearer ${getToken()}` };
    console.log('url', this.props.serviceURL + urls.GET_CID_FROM_AD_URL);
    fetch(this.props.serviceURL + urls.GET_CID_FROM_AD_URL, {
      headers,
    }).then((response) => {
      if (response.ok) {
        response.json().then((json) => {
          if (json.userInactive == true) {
            window.location.pathname = '/deactivated';
            return;
          }
          sessionStorage.setItem('isUsingAAD', 'true');
          sessionStorage.setItem('isLocalLogin', 'false');
          let user = json.loggedInUser;
          user.token = json.token;
          try {
            //let userRole = user.userRoles[0].roleId
            const canHang = user.userRoles.some(x => x.roleId == 1);
            let expDate = new Date();
            expDate.setTime(expDate.getTime() + 8.64e7);
            if (canHang) document.cookie = 'canHang=true;expires=' + expDate.toUTCString();
          } catch (exception) {
            console.log('Cookie error: ', exception)
          }
          this.props.setUserInfo(user);
        });
      }
    });
  };

  public render() {
    if (
      this.props.currentUser ||
      sessionStorage.getItem('signedOut') == 'true'
    ) {
      return <React.Fragment />;
    }
    this.getCidUserWithADUser();
    return <div className='divAad'>Logging In</div>;
  }
}
